var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { useMemo } from 'react';
import { shallow } from 'zustand/shallow';
import { FOCUS_KEY } from '@tving/utils/src/constants/focusKeyConstants';
import useMount from '@tving/utils/src/hooks/common/useMount';
import { FocusParentContext, useFocusable } from '@tving/utils/src/utils/tving-focusable';
import { EventDelegator } from '@/index';
import { usePopup } from '@stores/popup';
import SquareButtonLayer from '../button/SquareButtonLayer';
import StyledPopupLayer from './PopupLayer.style';
/**
 * 팝업 타입별 SquareButtonLayerProps를 반환
 * 반환 시 필요한 callback action도 함께 정의한다.
 * 아래 정의된 버튼으로 구현이 어려운 경우 직접 구현
 */
var PopupLayer = function () {
    var _a;
    var _b = __read(usePopup(function (state) { return [state.popupInfo, state.hidePopup]; }, shallow), 2), popupInfo = _b[0], hidePopup = _b[1];
    var _c = useFocusable({
        isFocusBoundary: true,
        trackChildren: true,
        focusKey: FOCUS_KEY.POPUP(),
        preferredChildFocusKey: FOCUS_KEY.POPUP_BUTTON(0),
        onBackPress: function () {
            if (popupInfo === null || popupInfo === void 0 ? void 0 : popupInfo.handelBackPress) {
                popupInfo === null || popupInfo === void 0 ? void 0 : popupInfo.handelBackPress();
            }
            hidePopup();
        },
    }), focusKey = _c.focusKey, ref = _c.ref, setFocus = _c.setFocus, keyDownEventListener = _c.keyDownEventListener, keyUpEventListener = _c.keyUpEventListener;
    useMount(function () {
        var _a;
        if (popupInfo) {
            var activeIndex = ((_a = popupInfo.buttons) === null || _a === void 0 ? void 0 : _a.findIndex(function (button) { return button.isActive; })) || 0;
            setFocus(FOCUS_KEY.POPUP_BUTTON(activeIndex > -1 ? activeIndex : 0));
            EventDelegator.addPriorityEventListener('keydown', keyDownEventListener);
            EventDelegator.addPriorityEventListener('keyup', keyUpEventListener);
        }
        return function () {
            EventDelegator.removePriorityEventListener('keydown', keyDownEventListener);
            EventDelegator.removePriorityEventListener('keyup', keyUpEventListener);
        };
    }, [popupInfo]);
    var convertedButtons = useMemo(function () {
        if (popupInfo && popupInfo.texts && popupInfo.buttons && popupInfo.buttons.length > 0) {
            return popupInfo.buttons.map(function (button, index) { return (_createElement(SquareButtonLayer, __assign({}, button, { focusKey: FOCUS_KEY.POPUP_BUTTON(index), text: button.text || '확인', handleSelect: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                // 어떤 버튼 선택 콜백 함수를 정의했든, 끝내고 팝업창을 닫게함
                                hidePopup();
                                if (!button.handleSelect) return [3 /*break*/, 2];
                                return [4 /*yield*/, button.handleSelect()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }, className: "popup-button", key: index.toString() }))); });
        }
        return (_jsx(SquareButtonLayer, { focusKey: FOCUS_KEY.POPUP_BUTTON(0), text: "\uD655\uC778", handleSelect: function () {
                hidePopup();
            }, className: "popup-button" }));
        // return [];
    }, [popupInfo, hidePopup]);
    return (_jsx(StyledPopupLayer, __assign({ enabled: !!popupInfo, ref: ref }, { children: _jsx(FocusParentContext.Provider, __assign({ value: focusKey }, { children: _jsxs("section", { children: [_jsxs("section", __assign({ className: "texts" }, { children: [_jsx("h1", { children: "\uC54C\uB9BC" }), _jsx("article", { children: popupInfo && popupInfo.texts
                                    ? popupInfo.texts.map(function (text, index) {
                                        return _jsx("h2", { children: text }, index.toString());
                                    })
                                    : null })] })), _jsx("section", __assign({ className: (popupInfo === null || popupInfo === void 0 ? void 0 : popupInfo.buttons) && ((_a = popupInfo.buttons) === null || _a === void 0 ? void 0 : _a.length) > 1 ? 'buttons multi' : 'buttons' }, { children: convertedButtons }))] }) })) })));
};
export default PopupLayer;
